import adminAxiosInstance from "./api/adminAxiosInstance";

const getVariables = async () => {
  const response = await adminAxiosInstance.get("goldenvariable");
  return response.data;
};

const saveVariables = async (payload) => {
  const response = await adminAxiosInstance.post("goldenvariable", payload);
  return response.data;
};

const updatePromotionName = async (name) => {
  const response = await adminAxiosInstance.patch("goldenvariable/promotion-name", { name });
  return response.data;
};

export const goldenVariableService = {
  getVariables,
  saveVariables,
  updatePromotionName,
};